import 'react-responsive-carousel/lib/styles/carousel.min.css';
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import PropTypes from 'prop-types';

const CardCarousel = ({ children, ...rest }) => (children.length > 1
  ? <Carousel {...rest}>{children}</Carousel> : <>{children}</>);

CardCarousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default CardCarousel;
